export default "__VITE_ASSET__1cce7daa__"